import type { GatsbyBrowser } from 'gatsby';
import React from 'react';
import { ThemeProvider } from './src/components/theme-provider';
import './src/styles/main.scss';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) =>
  React.createElement(ThemeProvider, null, element);
